import { useExtensionModel } from '@/store/models/extensions-model';

export const useExtensionHelper = () => {
    const display = useExtensionModel((state) => state.display);
    const setDisplay = useExtensionModel((actions) => actions.setDisplay);

    const style = useExtensionModel((state) => state.style);
    const setStyle = useExtensionModel((actions) => actions.setStyle);

    const type = useExtensionModel((state) => state.type);
    const setType = useExtensionModel((actions) => actions.setType);

    return {
        display,
        setDisplay,
        style,
        setStyle,
        type,
        setType,
    };
};
